<script setup lang="ts">
import { type PropType } from 'vue';
import { AxialForm } from '@common';

import { useDecisionSupportWizardParcelCard } from '../../composables/decision-support-wizard-parcel-card.composable';
import type { DecisionSupportWizardParcelData } from '../../models/decision-support-wizard.model';

const props = defineProps({
  parcel: {
    type: Object as PropType<DecisionSupportWizardParcelData>,
    required: true
  }
});

const emit = defineEmits(['zoomToExtent', 'removeParcel']);

const { form, isLoading, parcelItem, sourceMissing, zoomToExtent, removeParcel } = useDecisionSupportWizardParcelCard(
  props.parcel,
  emit
);
</script>

<template>
  <v-card
    variant="elevated"
    :loading="isLoading"
    :disabled="isLoading"
    class="decision-support-wizard-parcel-card">
    <template #prepend>
      <div class="decision-support-wizard-parcel-card__icon">
        <div
          v-if="parcel.svg"
          class="d-flex align-center justify-center w-100 h-100"
          v-html="parcel.svg" />
        <v-icon
          v-else
          style="opacity: 0.3"
          icon="mdi-image-off-outline"
          size="6rem"
          color="grey-lighten-1" />
        <v-icon
          class="position-absolute"
          style="filter: drop-shadow(0 0 8px white)"
          size="3rem" />
      </div>
    </template>
    <template #append>
      <div class="d-flex flex-column gap-1">
        <v-btn
          variant="flat"
          size="x-small"
          :icon="true"
          @click.prevent.stop="zoomToExtent()">
          <v-icon
            icon="mdi-magnify-plus-outline"
            size="x-large" />
        </v-btn>
        <v-btn
          variant="flat"
          size="x-small"
          :icon="true"
          @click.prevent.stop="removeParcel()">
          <v-icon
            icon="mdi-close"
            size="x-large"
            color="error" />
        </v-btn>
      </div>
    </template>
    <template #title>
      <div class="decision-support-wizard-parcel-card__title">
        <span>{{ parcelItem.name }}</span>
        <span class="text-grey ml-3 font-weight-light">{{ parcelItem.area }} ha</span>
      </div>
    </template>
    <template #item>
      <div
        v-if="!parcelItem.blocked"
        class="mt-4">
        <axial-form
          v-if="form"
          id="statisticsWizardParcelForm"
          :form="form.element" />
      </div>
      <div v-else>
        <p class="text-error">{{ $t('statistics.wizard.label.blockedParcel') }}</p>
      </div>
      <div
        v-if="sourceMissing"
        class="d-flex align-center ga-2">
        <v-icon
          color="error"
          size="small"
          icon="mdi-alert" />
        <p class="text-error py-2">{{ $t('decisionSupport.wizard.label.sourceMissing') }}</p>
      </div>
    </template>
  </v-card>
</template>
